<div id="reports-list-modal" class="common-popup-view">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Solicitudes de dirección</h2>
    </div>

    <form [formGroup]="requestForm">
        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="block-looper">
                    <div class="full">
                        <h2>Gestor</h2>
                        <mat-form-field appearance="fill">
                            <mat-select [(value)]="SelectedAdministrativeUser" formControlName="SelectedAdministrativeUser"
                                (selectionChange)="onAdminUserChange($event)">
                                <mat-option *ngFor="let user of admintrativeUsers" [value]="user.administrativa">
                                    {{user.nombre}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>                     
                    </div>                   
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button mat-button color="primary" class="keep" (click)="onSubmit()"><span
                    class="mat-button-wrapper unset-position">Aceptar</span></button>
            <button mat-button color="accent" class="cancel" (click)="close()"><span
                    class="mat-button-wrapper unset-position">Cancelar</span></button>
        </div>
    </form>
</div>